(function() {
    'use strict';

	angular.module('app').animation('.slide-and-fade', [function() {
	    return {
	        enter: function(element, doneFn) {
	            // var height = $(element).get(0).scrollHeight;
	            var height = $(element).outerHeight();

	            $(element).css('opacity', 0);
	            $(element).css('height', 0);

	            $(element).animate({
	                opacity:1,
	                height: height
	            }, 500);
	        },
	        leave : function(element, done) {
	            $(element).animate({
	                height: 0,
	                opacity: 0,
	                display:'none'
	            }, 500, function(){
	            	element.addClass('hidden');
	            });

	            // optional onDone or onCancel callback
	            // function to handle any post-animation
	            // cleanup operations
	            return function(isCancelled) {
	                if(isCancelled) {
	                    $(element).stop();
	                }
	            }
	        },
	    }
	}]);

}());